export enum ManageTableRowType {
  Segment = 'Segment',
  SegmentGroup = 'SegmentGroup',
  Goal = 'Goal',
  Campaign = 'Campaign',
  ExpenseGroup = 'ExpenseGroup',
  UnassignedExpenses = 'UnassignedExpenses'
}
